import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { ITaskV2 } from '@fi-app/task-v2/fi-task-v2';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ObjectTypes } from '@fi-shared/types';
import { Animations } from '@fi-shared/utils/animations';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Component({
    selector: 'fi-task-v2-edit-name',
    templateUrl: './fi-task-v2-edit-name.component.html',
    styleUrl: './fi-task-v2-edit-name.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-edit-name' },
    animations: [Animations.fadeHeight()],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiTaskV2EditNameComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiTaskV2EditNameComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiTaskV2EditNameComponent extends ControlValueAccessorValidatorBase<ITaskV2> {
    protected readonly ObjectTypes = ObjectTypes;

    private readonly fiUserDataService = inject(FiUserDataService);
    protected preferredLanguageId = this.fiUserDataService.getContentLanguage();

    get task(): ITaskV2 {
        return this.ngModel;
    }
}
